import { useAuth } from '../../contexts/AuthContext'

interface PermissionProps {
  /** 所需权限码（满足其一即显示），与登录接口 buttonPermissions 一致 */
  code?: string
  codes?: string[]
  children: React.ReactNode
}

/**
 * 根据当前用户按钮权限控制子节点显示/隐藏（如新增、编辑、删除按钮）
 */
export default function Permission({ code, codes, children }: PermissionProps) {
  const { hasPermission } = useAuth()
  const list = code ? [code] : codes ?? []
  const hasAny = list.length === 0 || list.some((c) => hasPermission(c))
  if (!hasAny) return null
  return <>{children}</>
}
